import React from 'react';
import { PrismicRichText } from '@prismicio/react';
import classNames from 'classnames';
import styles from './table-with-columns.module.scss';
/**
 * @typedef {import("@prismicio/client").Content.TableTwoColumnsSlice} TableTwoColumnsSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<TableTwoColumnsSlice>} TableTwoColumnsProps
 * @param { TableTwoColumnsProps }
 */
const TableWithColumns = ({ slice }) => (
    <div className={'table-with-columns w-full'} role="table">
        {slice.items &&
            slice.items.map((item, index) => {
                const rowStyles = {
                    borderColor: slice.primary.border_colour || null,
                    color: slice.primary.text_colour || null,
                };
                return (
                    <div
                        key={index}
                        role="row"
                        className={classNames(
                            styles['row']
                        )}
                        style={rowStyles}
                    >
                        <div role={'cell'}>
                            <PrismicRichText field={item.label} />
                        </div>
                        <div role={'cell'}>
                            <PrismicRichText field={item.value} />
                        </div>
                    </div>
                );
            })}
    </div>
);

export default TableWithColumns;
